import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import Seo from "../components/site/Seo";
import Html from "../components/site/Html";
import { Code2, Smartphone, Globe, Layers, Cloud, Cpu } from "lucide-react";

const services = [
  { icon: Smartphone, title: "Mobile App Development", desc: "iOS & Android apps with Flutter, React Native or native stacks." },
  { icon: Globe, title: "Web Platforms", desc: "Performant marketing sites, dashboards, SaaS web apps." },
  { icon: Layers, title: "Custom Software", desc: "ERPs, CRMs, internal tools tailored to your operations." },
  { icon: Cloud, title: "DevOps & Cloud", desc: "AWS, GCP, Kubernetes, CI/CD, observability." },
  { icon: Cpu, title: "AI Integrations", desc: "OpenAI, Gemini & custom ML pipelines into your product." },
  { icon: Code2, title: "Product Engineering", desc: "Senior engineers embedded with your team, end-to-end." },
];

const Services = () => {
  const { settings } = useSettings();
  return (
    <div data-testid="services-page">
      <Seo
        title="Services — Reptile Global"
        description="App, web and software development services from Reptile Global."
        organizationSchema={settings?.organization_schema}
      />
      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">Services</div>
            <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter text-zinc-950 leading-[0.95]">
              From an idea to <span className="text-green-600">production</span>, we ship.
            </h1>
            {settings?.services_content ? (
              <Html html={settings.services_content} className="mt-6 text-lg text-zinc-700" />
            ) : (
              <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
                We partner with founders and enterprises to design and engineer mobile apps, web platforms and custom software. Senior team. Real outcomes.
              </p>
            )}
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <div key={i} className="bg-white border border-zinc-200 rounded-2xl p-8 hover:-translate-y-1 hover:shadow-md transition-all">
                <div className="w-12 h-12 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center mb-5"><s.icon size={22} /></div>
                <div className="font-display font-bold text-xl text-zinc-900 mb-2">{s.title}</div>
                <div className="text-sm text-zinc-600 leading-relaxed">{s.desc}</div>
              </div>
            ))}
          </div>

          <div className="mt-20 rounded-3xl bg-zinc-950 px-8 sm:px-16 py-16 text-center relative overflow-hidden">
            <div className="absolute -top-16 -left-16 w-80 h-80 bg-green-500/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-16 -right-16 w-80 h-80 bg-orange-500/30 rounded-full blur-3xl" />
            <h3 className="relative font-display text-3xl sm:text-4xl font-black tracking-tighter text-white">Have a project in mind?</h3>
            <p className="relative mt-3 text-zinc-400 max-w-xl mx-auto">Tell us about it. We'll respond within one business day.</p>
            <Link to="/contact" className="relative mt-8 inline-flex bg-orange-500 hover:bg-orange-600 text-white px-8 py-3.5 rounded-full font-semibold" data-testid="services-cta">Start a project →</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
